/**
 * This component is a container for the template collections of all Stock, Custom and
 * Input types. Mapping them as <FormTemplateLibraryItem /> components, and in case there's
 * a selectedTemplateId, passing isSelected as a prop to highlight the selection for the
 * Click and Add to Form flow.
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';

import FormTemplateLibraryItem from './FormTemplateLibraryItem';
import { getUserFacingTemplateLabel, getTemplateSubtitle } from '../../utils/templateLibrary';
import { getSelectedTemplateId } from '../../selectors/templateLibrary';

const CollectionContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    &::after {
        content: '';
        flex-basis: 30%;
    }
`;

const FormTemplateLibraryCollection = ({
    templates,
    onClickTemplate,
    onRemoveTemplate,
    alreadyAddedUniqueNames,
    selectedTemplateId,
    qaId,
    disabledItems,
}) => (
    <CollectionContainer data-qa={`${qaId}__collection`}>
        {templates.map((template) => (
            <FormTemplateLibraryItem
                key={template.id}
                template={template}
                onClickTemplate={onClickTemplate}
                onRemoveTemplate={onRemoveTemplate}
                templateId={template.templateId}
                templateLabel={getUserFacingTemplateLabel(template)}
                templateSubtitle={getTemplateSubtitle(template)}
                templateDescription={template.data.description}
                disabled={alreadyAddedUniqueNames.includes(template.data.name) || disabledItems}
                isSelected={selectedTemplateId === template.id}
            />
        ))}
    </CollectionContainer>
);

FormTemplateLibraryCollection.propTypes = {
    templates: PropTypes.array,
    onClickTemplate: PropTypes.func.isRequired,
    onRemoveTemplate: PropTypes.func,
    alreadyAddedUniqueNames: PropTypes.array,
    selectedTemplateId: PropTypes.string,
    qaId: PropTypes.string.isRequired,
    disabledItems: PropTypes.bool,
};

FormTemplateLibraryCollection.defaultProps = {
    templates: [],
    onRemoveTemplate: undefined,
    alreadyAddedUniqueNames: [],
    selectedTemplateId: null,
    disabledItems: false,
};

const mapStateToProps = (state) => {
    const selectedTemplateId = getSelectedTemplateId(state);

    return {
        selectedTemplateId,
    };
};

export default connect(mapStateToProps)(FormTemplateLibraryCollection);
